<template>
	<div class="account-page">
		<Header/>
		<LoggedInUserHeader/>
		<div class="account-wrapper">
			<Sidebar
				:currentUser='currentUser'
			/>
			<div class="account">
				<div class="account-header">
					<h1 class="title">My Account</h1>
					<div class="updates">
						<div class="update-error alert-custom" v-if="true">
							<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M13.0605 10.9393L3.06055 0.939331L0.939226 3.06065L10.9392 13.0607L13.0605 10.9393Z" fill="#F26464"/>
								<path fill-rule="evenodd" clip-rule="evenodd" d="M0.939453 10.9393L10.9395 0.939331L13.0608 3.06065L3.06077 13.0607L0.939453 10.9393Z" fill="#F26464"/>
							</svg>
							<p>Account update failed</p>
						</div>
						<div class="update-success">
							<svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M7.00011 9.87867L15.9395 0.939331L18.0608 3.06065L7.00011 14.1213L0.939453 8.06065L3.06077 5.93933L7.00011 9.87867Z" fill="#45A66C"/>
							</svg>
							<p>Account updated successfully</p>
						</div>
					</div>
        <div class="errors" v-if='currentUser.tier=="FREE"'>
          <p class="alert-custom"><span>{{currentUser.remainingSearches}}</span> searches left! To continue using all features choose <router-link to="/pricing-plan">pricing plan</router-link>.</p>
        </div>
				</div>
				<div class="user-account-view">
					<div class="user-actions-main">
						<LoadAnimation 
							v-if='this.$store.state.isLoading'
						/>
						<AccountDetails 
							data-id="1"
							class="account-tab-item account-tab-item-acc-d"
							:loggedInUser='currentUser'
							v-bind:class="{ isLoading: this.$store.state.isLoading }"
							@updated='accountSuccess'
							@error='accountError'
						/>
						<AccountFeedback 
							data-id="2"
							class="account-tab-item account-tab-item-feed-d"
							v-bind:class="{ isLoading: this.$store.state.isLoading }"
						/>
						<PricingPlan 
							data-id="3"
							class="account-tab-item"
							style="display: none;"
							v-bind:class="{ isLoading: this.$store.state.isLoading }"
						/>
					</div>
					<AccountNavigation
						@click='changeTab'
					/>
				</div>
			</div>			
		</div>
		<Footer/>
		<!-- <DeleteModal/> -->
	</div>
</template>
<script>
import Header from '@/components/layout/header.vue';
import LoggedInUserHeader from '@/components/user/dashboard/core/TopBar.vue';
import Sidebar from '@/components/user/dashboard/core/sidebar.vue';
import AccountNavigation from '@/components/user/account/navigation.vue'
import AccountDetails from '@/components/user/account/account-details.vue';
import AccountFeedback from '@/components/user/account/feedback.vue';
import PricingPlan from '@/components/global/pricing-plan.vue';
// import DeleteModal from '@/components/user/modals/delete.vue';
import LoadAnimation from '@/components/global/loadAnimation.vue';
import Footer from '@/components/layout/footer.vue';
import * as isUserLoggedIn from '@/store/isUserLoggedIn';
import {axiosClient} from "@/axios-client";


	export default {
		name: 'account',
		components: {
			Header,
			LoggedInUserHeader,
			Sidebar,
			AccountNavigation,
			AccountDetails,
			AccountFeedback,
			PricingPlan,
			// DeleteModal,
			LoadAnimation,
			Footer
		},

		data() {
			return {
				user: isUserLoggedIn.isUserLoggedIn(),
				currentUser: {},
			}
		},

		created() {
			this.$store.commit('resultsAreLoading');

			axiosClient.get('v1/account')
				.then((response) => {
					this.currentUser = response.data;
					this.$store.commit('resultsLoaded');
				})
		},

		methods: {
			changeTab(currentTab) {
				let tabId = currentTab.getAttribute('data-id');
				let tabItems = document.querySelectorAll('.account-tab-item');
				for(let tabItem of tabItems) {
					tabItem.style.display = 'none';
					let tabItemId = tabItem.getAttribute('data-id');

					if(tabItemId == tabId) {
						tabItem.style.display = "block";
					}
				}
			},

			accountSuccess() {
				document.querySelector('.update-success').style.display = 'flex';
			},

			accountError() {
				document.querySelector('.update-error').style.display = 'flex';
			},
		}
	};
</script>

<style lang="scss">
	.account-page {
		.account-wrapper {
			display: flex;
			justify-content: space-between;
			background: #f9f9f9;
			min-height: 100vh;

			.account {
				width: 70%; //70%
				margin: 40px auto 0 auto;
				padding-bottom: 75px;

				.account-header {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 30px;

					.updates {
						display: flex;
						flex-direction: column;
						align-items: flex-start;

						p {
							margin: 0;
							font-size: 14px;
							line-height: 31px;
						}

						.update-error,
						.update-success {
							display: none;
							align-items: center;

							svg {
								margin-right: 11px;
							}
						}
					}

					.alert-custom {
            color: #F26464;
            background: #FDEFED;
            border: 1px solid #F26464;
            border-radius: 5px;
            padding: 2px 27px;
						margin: 0;

            a {
              color: #333;
              text-decoration: underline;
            }
          }

					.update-success {
						background: #DEF4E3;
						border: 1px solid #45A66C;
						border-radius: 5px;
						color: #45A66C;
						padding: 2px 17px;
					}
				}

				.user-account-view {
					display: flex;
					justify-content: space-between;
					align-items: flex-start;

					.isLoading {
						display: none;
					}

					.container {
						max-width: 1320px;
					}

					.user-actions-main {
						width: 80%;
						margin-right: 5%;
						background: #FFFFFF;
						box-shadow: 0px 4px 15px rgba(51, 51, 51, 0.03);
						border-radius: 15px;
						// padding: 50px 0;

						.loader-container {
							top: 50%;
						}

						.free-wrapper {
							.featured {
								p, 
								span, 
								h5, 
								ul, 
								del, 
								.per-year {
									padding: 0 40px;
								}

								a {
									margin: 0 40px;
								}

								ul {
									padding-inline-start: 60px;
								}

								.per-year {
									p {
										padding: 0;
									}
								}
							}

							.markets {
								padding-left: 40px;
								background: url('~@/assets/images/components/fee-alternate.svg') bottom right no-repeat;

								.market-items {
									.market-item {
										margin-right: 2.5rem;

										.coming-br {
											display: inline;
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
</style>